import { Box, Radio, RadioGroup, Stack, Text, useToast } from "@chakra-ui/react";
import { ReactComponent as Edit } from '../../svg/Edit.svg'
import { ReactComponent as Delete } from '../../svg/Delete.svg'
import { useState } from "react";
import EditDialog from "./EditDialog";
import DeleteAlertDialog from "../common/DeleteAlertDialog";
import { useEffect } from "react";

export default function Question({ question, choices, id, deleteHandler, editHandler }) {
    const [isDeleteOpen, setIsDeleteOpen] = useState(false)
    const [isEditOpen, setIsEditOpen] = useState(false)
    const toast = useToast()
    const [defaultValue, setDefaultValue] = useState(choices.find(option => option.is_right_choice === 'Y')?.choice || null)

    const onDeleteClose = () => setIsDeleteOpen(false)
    const onEditClose = () => setIsEditOpen(false)

    const questionEditHandler = (editedQuestion) => {
        onEditClose()
        editHandler(editedQuestion, id)
    }

    const questionDeleteHandler = () => {
        onDeleteClose()
        deleteHandler(question.id)
        toast({
            title: "Question Deleted Successfully!",
            description: "Question Deleted!",
            status: "success",
            duration: 1000,
            isClosable: true,
        })
    }
    useEffect(() => {
        setDefaultValue(choices.find(option => option.is_right_choice === 'Y')?.choice)
    }, [choices])

    return (
        <Box p='1.5rem' position='relative' width={['100%', '100%', '90%', '90%', '85%']} borderRadius='lg' bg='white' boxShadow='lg' d='flex' flexDir='column' justifyContent={['center', 'center', 'flex-start', 'flex-start']} mt='2rem'>
            <Box d='flex' justifyContent='space-between' alignItems='flex-start'>
                <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontSize={['16px', '16px', '18px']} color='#3333333' fontWeight='600' mb='1'>{question.question_title}</Text>
                <Box d='flex' justifyContent='center' alignItems='center' style={{ gap: '1rem' }} ml='2'>
                    <Edit cursor='pointer' width='18px' height='18px' onClick={() => setIsEditOpen(true)} />
                    <Delete cursor='pointer' width='18px' height='18px' onClick={() => setIsDeleteOpen(true)} />
                </Box>
            </Box>

            <RadioGroup
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontSize={['14px', '16px', '18px']}
                color='#3333333'
                fontWeight='600'
                pointerEvents='none'
                value={defaultValue || -1}
                colorScheme='switch'
            >
                <Stack direction="column">
                    {
                        choices.map((option, idx) => <Radio mb='0.5' key={idx} value={option.choice}>{option.choice}</Radio>)
                    }
                </Stack>
            </RadioGroup>

            <EditDialog
                isOpen={isEditOpen}
                onClose={onEditClose}
                method={questionEditHandler}
                question={question}
                options={choices.map(choice => {
                    let newChoice = {}
                    Object.assign(newChoice, choice)
                    return newChoice
                })}
                existingChoice = {choices}
            />

            <DeleteAlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} method={questionDeleteHandler} text={'Question'} />
        </Box>
    )
}